<h3 class="greeting accent set-font-family">{{'MSG.GREETING' | translate}}</h3>
<small class="login-title accent set-font-family">{{'LABEL.LOGIN_TO_ACC' | translate}}</small>
<form id="login-form" (ngSubmit)="onSubmit()" [formGroup]="loginForm" class="flex-col label-control">
    <label class="text-light label-control" for="email">{{'LABEL.EMAIL' | translate }}</label>
    <mat-form-field class="login-form-field" color="accent" appearance="outline">
        <input formControlName="email" id="email" type="email" autocomplete="email" matInput required [placeholder]="'LABEL.EMAIL' | translate">
        <mat-icon matPrefix svgIcon="email"></mat-icon>
    </mat-form-field>
    <mat-error @fade *ngIf="emailControl.invalid && emailControl.touched && !emailControl.errors?.email">
        {{ 'MSG.EMAIL_REQUIRED' | translate }}
    </mat-error>
    <mat-error @fade *ngIf="emailControl.errors?.email">
        {{ 'MSG.VALID_EMAIL_REQUIRED' | translate }}
    </mat-error>

    <label class="text-light label-control" for="password">{{ 'LABEL.PASSWORD' | translate }}</label>
    <mat-form-field class="login-form-field" color="accent" appearance="outline" class="password">
        <input id="password" type="password" matInput required autocomplete="current-password" #pwd formControlName="password" [placeholder]="'LABEL.PASSWORD' | translate">
        <mat-icon matPrefix svgIcon="password"></mat-icon>
        <button type="button" class="icon-color" (click)="toggleInput(pwd)" matSuffix mat-icon-button><mat-icon>{{ 'visibility' + (pwd.type == 'password' ? '_off' : '') }}</mat-icon></button>
    </mat-form-field>
    <mat-error @fade *ngIf="passwordControl.invalid && passwordControl.touched">{{ 'MSG.PASSWORD_REQUIRED' | translate }}</mat-error>

    <div class="flex-row between set">
        <a class="accent" routerLink="/auth/forgot-password">{{'LABEL.FORGET_PASSWORD' | translate}}</a>
    </div>
    <mat-error @fade *ngIf="isWrong" class="alert alert-danger">
        <p>{{'MSG.INVALID_LOGIN' | translate}}</p>
    </mat-error>
    <ng-container *ngIf="loginForm.errors">
        <mat-error class="error set-padding" @fade *ngIf="loginForm.errors.incorrect">{{ 'MSG.LOGIN_INCORRECT' | translate }}</mat-error>
        <mat-error class="error" @fade *ngIf="loginForm.errors.error">{{ 'MSG.LOGIN_ERROR' | translate }}</mat-error>
    </ng-container>
    <button color="accent" mat-flat-button [disabled]="submitted" type="submit" class="submit">
		{{'LABEL.SIGNIN' | translate}}
	</button>
    <div class="other-signin">
        <span class="border"></span>
        <span class="desc">{{'MSG.OR' | translate}}</span>
    </div>
</form>
<div class="social-signin-wrapper">
    <button mat-button id="google-signin">
      <span class="icon"></span>
      <span class="label mobile">{{'BUTTON.GOOGLE' | translate}}</span>
    </button>
    <button mat-button id="apple-signin-btn" (click)="onSigninWithApple()">
      <span class="icon"></span>
      <span class="label mobile">{{'BUTTON.APPLE' | translate}}</span>
    </button>
    <button mat-button id="facebook-signin" (click)="onSigninWithFacebook()">
      <span class="icon"></span>
      <span class="label mobile">{{'BUTTON.FACEBOOK' | translate}}</span>
    </button>

</div>
<div class="alert">
    <p>{{'MSG.DONT_HAVE_ACC' | translate}} <a class="accent" routerLink="/auth/register">{{'LABEL.REGISTER_HERE' | translate}}</a></p>
</div>